import { colorFamily } from "@/lib/colorFamily";

export const SWATCHES = {
  white: "#f4f4f5",
  cream: "#f5efe0",
  ivory: "#f7f3e8",
  beige: "#e0d5c0",
  sand: "#dcc9a6",
  taupe: "#b6a898",
  silver: "#c0c4c8",
  grey: "#9ca3af",
  gray: "#9ca3af",
  charcoal: "#3f3f46",
  black: "#18181b",
  gold: "#c9a227",
  brass: "#b08d57",
  copper: "#b87333",
  bronze: "#8c7853",
  cognac: "#8d5524",
  brown: "#7c5a3a",
  rust: "#9c4a2f",
  red: "#b3323a",
  pink: "#d8a0a6",
  navy: "#2a3a5c",
  blue: "#4a6fa5",
  emerald: "#2f7d5f",
  green: "#4a7c59",
  teal: "#2f7d7d",
  yellow: "#d7b740",
};

// Ordered palette staff can tap on the slab form (each maps to a SWATCHES hex).
export const PALETTE = [
  "White", "Cream", "Ivory", "Beige", "Sand", "Taupe", "Silver", "Grey",
  "Charcoal", "Black", "Gold", "Brass", "Copper", "Bronze", "Brown", "Rust",
  "Red", "Pink", "Navy", "Blue", "Teal", "Emerald", "Green", "Yellow",
];

export const swatchFor = (name) => {
  const text = String(name || "").toLowerCase();
  const hit = Object.keys(SWATCHES).find((key) => text.includes(key));
  return hit ? SWATCHES[hit] : null;
};

const Chip = ({ label, value, site = false }) => {
  const raw = String(value || "").trim();
  const hex = /^#?[0-9a-fA-F]{3}$|^#?[0-9a-fA-F]{6}$/.test(raw)
    ? raw.startsWith("#")
      ? raw
      : `#${raw}`
    : null;
  const name = hex ? colorFamily(hex) || raw : raw;
  return (
    <span
      title={`${label} color: ${raw}`}
      className={
        site
          ? "inline-flex h-11 max-w-full items-center gap-2.5 rounded-[14px] bg-[#f3f1ec] pl-1.5 pr-4 text-sm font-medium text-[color:var(--s-ink)]"
          : "inline-flex max-w-full items-center gap-2 rounded-md border border-zinc-800 bg-zinc-950 px-2 py-1 text-xs text-zinc-200"
      }
    >
      <span
        aria-hidden
        className={
          site
            ? "h-8 w-8 shrink-0 rounded-[10px] ring-1 ring-black/10"
            : "h-7 w-7 shrink-0 rounded-none border border-white/20"
        }
        style={{
          background:
            hex || swatchFor(raw) || "linear-gradient(135deg,#52525b,#a1a1aa)",
        }}
      />
      <span className="truncate">{name}</span>
    </span>
  );
};

// A color field may hold several comma-separated colors ("White, Gold") — each
// becomes its own swatch chip.
export const splitColors = (v) =>
  String(v || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

// Primary / accent slab colors shown as swatch chips on cards and tiles.
// `site` switches to the public website's rounded, warm look.
export const ColorChips = ({
  primary,
  accent,
  testId,
  className = "",
  site = false,
}) => {
  const primaries = splitColors(primary);
  const accents = splitColors(accent);
  if (!primaries.length && !accents.length) return null;
  return (
    <span
      data-testid={testId}
      className={`inline-flex flex-wrap items-center ${site ? "gap-2" : "gap-1.5"} ${className}`}
    >
      {primaries.map((v, i) => (
        <Chip key={`p-${i}`} label="Primary" value={v} site={site} />
      ))}
      {accents.map((v, i) => (
        <Chip key={`a-${i}`} label="Accent" value={v} site={site} />
      ))}
    </span>
  );
};

export default ColorChips;
